import { render } from "./DragControl.vue?vue&type=template&id=49901515&scoped=true"
import script from "./DragControl.vue?vue&type=script&lang=js"
export * from "./DragControl.vue?vue&type=script&lang=js"

import "./DragControl.vue?vue&type=style&index=0&id=49901515&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lrive\\source\\repos\\XOneFrameworkWEB\\XOneWebVue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49901515"]])

export default __exports__